export default __webpack_public_path__ + "static/media/whatsnew.c5bacd3b.jpg";